import React, { Component } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { Image } from 'components/Image/Image';
import circleProfile from 'assets/img/icons/circle_profile.png';
import enkiLogo from 'assets/img/icons/enki-logo-light.png';
import { connect } from 'react-redux';
import { fetchCurrentUserData, receiveCurrentUserData } from 'store/actions/root/user';
import ScrollToTop from 'components/Commons/ScrollToTop/ScrollToTop';
import { getParams } from 'util.jsx';
import * as strings from './strings';
import UserMessageView from './components/UserMessageView/UserMessageView.component';
import { withResearchContext } from './ResearchContext.provider';
import { isCategorizedFollowUpQuestions } from 'models/user/research/FollowUpQuestion.model';
import SourcesView from './components/SourcesView/SourcesView.component';
import ShareNavBar from './components/ShareNavBar/ShareNavBar.component';
import ChatContentView from './components/ChatContentView/ChatContentView.component';
import './Research.scss';
import './components/ChatStreamView/ChatStreamView.scss';

const HOST = process.env.REACT_APP_SERVER;

function mdToHTML(md, stream = true) {
  const rxCommonMarkLink = /(\[([^\]]+)])\(([^)]+)\)/g;
  const rxBold = /\*\*([^\*]+)\*\*/g;
  const rxImage = /!\[([^\]]*)]\(([^)]+)\)/g;
  const rxHeadline = /^(#{1,6})\s+(.+?)\s*$/gm;

  // Apply headline conversion first (before other replacements) to handle both stream and non-stream modes
  const headingConverted = md
    ? md.replace(rxHeadline, (_, hashes, title) => {
      const level = hashes.length;
      return `<h${level}><b>${title.trim()}</b></h${level}>`;
    })
    : md;

  const anchor = headingConverted
    ? headingConverted
      .replace(rxBold, '<b>$1</b>')
      .replace(rxImage, '<img alt="$1" src="$2" style="max-height:500px" rel="noopener noreferrer"/>')
      .replace(rxCommonMarkLink, '<a target="_blank" href="$3">$2</a>')
    : headingConverted
    ;
  return anchor;
}

export class Share extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timestamp: Date.now(),
      chat: [],
      images: {},
      showingSources: {},
      reportMap: strings.reportMap,
      followUpQuestions: {},
      defaultFollowUpQuestions: strings.defaultFollowUpQuestions,
      reportFollowUpQuestions: strings.reportFollowUpQuestions,
      reportDescriptions: strings.reportDescriptions,
      shortReportDescriptions: strings.shortReportDescriptions,
      message: "",
      typing: false,
      expandingTyping: false,
      streaming: false,
      stop: false,
      autocomplete: false,
      showConversationHistory: false,
      conversationHistory: [],
      showMoreClicked: false,
      diveDeeperClicked: false,
      longReportType: "researchReport",
      imagesLoading: false,
      isSticky: false,
      myDataCheckBox: {
        id: 'useMyReportsData',
        text: 'Use Enki Reports Data',
        value: false,
        color: 'blue',
      },
      liteDataCheckBox: {
        id: 'liteData',
        text: 'Use On-Demand Data',
        value: true,
        color: 'blue',
      },
      modelDataCheckBox: {
        id: 'modelData',
        text: 'Use Idea Generation Data',
        value: false,
        color: 'blue',
      },
      longReportCheckBox: {
        id: 'longReport',
        text: 'In-Depth Analysis',
        value: true,
        color: 'blue',
      },
      shortReportCheckBox: {
        id: 'shortReport',
        text: 'Concise Summary',
        value: false,
        color: 'blue',
      },
      customReportCheckBox: {
        id: 'customReport',
        text: 'Generate A Custom Output For Idea Generation',
        value: false,
        color: 'blue',
      },
      startMyDataDate: '2020-01-01',
      endMyDataDate: (new Date()).toISOString().split('T')[0],
      startLiteDataDate: '2020-01-01',
      endLiteDataDate: (new Date()).toISOString().split('T')[0],
      systemPrompt: "",
      reportPrompt: "",
      keywordPrompt: "",
      model: "",
      linkCopied: false,
      fullscreenImage: null
    }
    this.chatRef = React.createRef();
    this.selectRef = React.createRef();
    this.stickyThreshold = 70; // Scroll threshold for sticky header
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollListenerAttached = false;
  }

  handleScroll() {
    const historyContainer = this.chatRef.current;
    if (historyContainer) {
      const scrollTop = historyContainer.scrollTop;
      const shouldBeSticky = scrollTop > this.stickyThreshold;
      if (shouldBeSticky !== this.state.isSticky) {
        this.setState({ isSticky: shouldBeSticky });
      }
    }
  }

  UNSAFE_componentWillMount() {
    this.props.fetchCurrentUserData();
    this.chatLoaded = false; // Flag to prevent multiple loadChat calls
  }

  componentDidMount() {
    const params = getParams(this.props.location);
    const reportType = params.has('t') && params.get('t');
    if (reportType) {
      this.setState({ longReportType: reportType });
      if (reportType in this.state.reportMap)
        document.title = `Enki - ${this.state.reportMap[reportType]}`;
    }

    // Add scroll listener for sticky header
    if (this.chatRef.current) {
      this.chatRef.current.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    // Clean up scroll listener
    if (this.chatRef.current) {
      this.chatRef.current.removeEventListener('scroll', this.handleScroll);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Attach scroll listener when chat data is loaded and ref becomes available
    if (this.chatRef.current && !this.scrollListenerAttached) {
      this.chatRef.current.addEventListener('scroll', this.handleScroll);
      this.scrollListenerAttached = true;
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    // Only proceed if chat hasn't been loaded yet
    if (this.chatLoaded) return;

    const { currentUserData = {} } = props;
    const params = getParams(this.props.location);
    const shareId = params.has('c') && params.get('c');

    if (!currentUserData.email || currentUserData.email == "demo@mail.com") {
      if (shareId) {
        this.chatLoaded = true; // Set flag before loading to prevent re-entry
        this.loadChat(shareId);
      }
    } else {
      this.props.history.push('/research?s=' + shareId);
    }
  }

  handleClick() {
    window.location.href = '/sign-up-senior';
  };

  handleShareClick = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      this.setState({ linkCopied: true });
      setTimeout(() => {
        this.setState({ linkCopied: false });
      }, 2000);
    });
  };

  handleImageClick = (event) => {
    const target = event.target;
    if (target.closest('.download-presentation-btn')) {
      window.location.href = '/sign-up-senior';
      return;
    }
    if (target.tagName === 'IMG' &&
      (target.classList.contains('presentation-image') || target.classList.contains('explore-chart-image') || target.closest('.research__form__message'))) {
      const imgSrc = target.src;
      this.setState({ fullscreenImage: imgSrc });
    }
  };

  closeFullscreenImage = () => {
    this.setState({ fullscreenImage: null });
  };

  loadChat = (shareId) => {
    // Set share mode in context so onShareClick copies current URL instead of creating new share
    if (this.props.researchContext?.actions?.setIsShareMode) {
      this.props.researchContext.actions.setIsShareMode(true);
    }

    fetch(`${HOST}/api/chat?shareId=${shareId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(response => response.json())
      .then(chatData => {
        if ("chat" in chatData) {
          this.setState({ chat: chatData.chat });
          // Also update context so UserMessageView can access the chat
          if (this.props.researchContext?.actions?.setChat) {
            this.props.researchContext.actions.setChat(chatData.chat);
          }
        }
        if ("details" in chatData && chatData.chat.length - 1 in chatData.details) {
          const details = chatData.details[chatData.chat.length - 1];
          // Extract followUpQuestions, longReportType, and artifactType from details
          const { followUpQuestions, longReportType, artifactType, ...otherDetails } = details;
          // Set other details first
          this.setState({ ...otherDetails });

          // Set longReportType to both state and context
          if (longReportType) {
            this.setState({ longReportType });
            if (this.props.researchContext?.actions?.setLongReportType) {
              this.props.researchContext.actions.setLongReportType(longReportType);
            }
          }

          // Set artifactType in context so UserMessageActions can show correct share option
          if (artifactType && this.props.researchContext?.actions?.setSharedArtifactType) {
            this.props.researchContext.actions.setSharedArtifactType(artifactType);
          }

          // Set followUpQuestions - handle both categorized and flat array formats
          if (followUpQuestions) {
            if (isCategorizedFollowUpQuestions(followUpQuestions)) {
              this.setState({ followUpQuestions });
              // Also update context so UserMessageView can access it
              if (this.props.researchContext?.actions?.setFollowUpQuestions) {
                this.props.researchContext.actions.setFollowUpQuestions(followUpQuestions);
              }
            } else if (Array.isArray(followUpQuestions)) {
              // If it's a flat array, keep it as is for the non-categorized render path
              this.setState({ followUpQuestions });
              // For context, we need to convert to categorized format
              if (this.props.researchContext?.actions?.setFollowUpQuestions) {
                this.props.researchContext.actions.setFollowUpQuestions({
                  followUpQuestions: [{ category: 'Suggested Questions', questions: followUpQuestions }]
                });
              }
            } else {
              // If it's in the categorized format from backend
              this.setState({ followUpQuestions });
              if (this.props.researchContext?.actions?.setFollowUpQuestions) {
                this.props.researchContext.actions.setFollowUpQuestions(followUpQuestions);
              }
            }
          } else {
            // If no follow-up questions from backend, clear any default ones in context
            if (this.props.researchContext?.actions?.setFollowUpQuestions) {
              this.props.researchContext.actions.setFollowUpQuestions({ followUpQuestions: [] });
            }
            this.setState({ followUpQuestions: {} });
          }
        }
      })
  }

  toggleSources = (idx) => {
    this.setState(prevState => ({
      showingSources: {
        ...prevState.showingSources,
        [idx]: !prevState.showingSources[idx]
      }
    }));
  }

  render() {
    const { chat, images, imagesLoading, followUpQuestions, defaultFollowUpQuestions, typing, streaming, longReportType, startLiteDataDate, endLiteDataDate, showMoreClicked } = this.state;
    const { mobileNavigationStatus, currentUserData = {} } = this.props;
    const { userType = 'demo' } = currentUserData;
    const autocompleteSuggestions = [...new Set(chat
      .filter(i => i.role == "user" && i.content.startsWith(this.state.message) && i.content.length > this.state.message.length)
      .map(i => i.content.trim())
    )];

    return (
      <div className={`margin-t-0 sidenav share-layout ${mobileNavigationStatus ? 'open' : ''}`}>
        <ShareNavBar
          longReportType={longReportType}
          startLiteDataDate={startLiteDataDate}
          endLiteDataDate={endLiteDataDate}
        />
        <div className="research research--share">
          <div className="research__form">
            <div className="research__form__history-container" ref={this.chatRef}>
              {chat.map((msg, idx) =>
                msg.role === "user" ? (
                  <UserMessageView
                    key={idx}
                    message={msg}
                    userProfile={currentUserData}
                    index={idx}
                    isLastQuestion={idx === chat.length - 2}
                    longReportType={this.state.longReportType}
                    showMoreClicked={showMoreClicked}
                    typing={typing}
                    streaming={streaming}
                    imagesLoading={imagesLoading}
                    images={images}
                    followUpQuestions={chat.length == 0 && defaultFollowUpQuestions.hasOwnProperty(longReportType) ? defaultFollowUpQuestions[longReportType] : followUpQuestions}
                    isSticky={idx === chat.length - 2 && this.state.isSticky}
                    hasScrollableArea={this.state.isSticky}
                  />
                ) : <div key={idx} className={"research__form__" + msg.role} >
                  <div className="research__form__image"><Image src={enkiLogo} /></div>
                  <div className="research__form__speaker">ENKI</div>
                  <div className="research__form__message" onClick={this.handleImageClick}><ChatContentView content={msg.content} onClick={this.handleImageClick} /></div>
                  <div className={"research__form__expand"}>
                    {chat.length > 0 && idx == chat.length - 1 && !typing && !streaming && !showMoreClicked && !imagesLoading ? <button className="a-icon-button" color="blue-grey" type="button" onClick={this.handleClick}><i className="material-icons">insights</i> Expand Search</button> : ""}
                    {chat.length > 0 && idx == chat.length - 1 && !(idx in images) && !typing && !streaming && !imagesLoading ? <button className="a-icon-button" color="green-dark" type="button" onClick={this.handleClick}><i className="material-icons">insert_chart</i> Explore Charts</button> : ""}
                    {chat.length > 0 && idx == chat.length - 1 && !typing && !streaming && !showMoreClicked && !imagesLoading && this.state.reportFollowUpQuestions.hasOwnProperty(this.state.longReportType) &&
                      this.state.reportFollowUpQuestions[this.state.longReportType].map(i => <button key={i} type="button" className="a-icon-button" color="blue-2" onClick={this.handleClick}><i className="material-icons">unfold_more</i> {i}</button>)}
                    {chat.length > 0 && msg.sources && msg.sources.length > 0 && !typing && !streaming ?
                      <button className="a-icon-button" color={this.state.showingSources[idx] ? "danger" : "blue-high"} type="button" onClick={() => this.toggleSources(idx)}>
                        <i className="material-icons">{this.state.showingSources[idx] ? 'close' : 'link'}</i>
                        {this.state.showingSources[idx] ? 'Hide Sources' : 'Sources'}
                      </button>
                      : ""}
                    {chat.length > 0 && !typing && !streaming ? <button className="a-icon-button" color="blue-high" type="button" onClick={this.handleShareClick}><i className="material-icons">{this.state.linkCopied ? 'check' : 'share'}</i> {this.state.linkCopied ? 'Link Copied' : 'Share'}</button> : ""}
                  </div>
                  {this.state.showingSources[idx] && msg.sources && msg.sources.length > 0 && (
                    <div className="research__form__sources" style={{ marginTop: '16px' }}>
                      <SourcesView sources={msg.sources} />
                    </div>
                  )}
                  {idx in images && <div className="research__form__message" dangerouslySetInnerHTML={{ __html: images[idx] }} onClick={this.handleImageClick}></div>}
                </div>
              )}

              <div className="research__form__row">
                {chat.length == 0 && <div className="research__form__description" dangerouslySetInnerHTML={{ __html: mdToHTML(this.state.reportDescriptions[longReportType]) }}></div>}
                <div className="research__form__followup-box">
                  {chat.length == 0 && <div className="research__form__short-description" dangerouslySetInnerHTML={{ __html: mdToHTML(this.state.shortReportDescriptions[longReportType]) }}></div>}
                  {chat.length > 0 && !isCategorizedFollowUpQuestions(followUpQuestions) && Array.isArray(followUpQuestions) && followUpQuestions.length > 0 && (
                    <>
                      {followUpQuestions.map((question, idx) => <div key={idx} className="research__form__followup" onClick={this.handleClick} dangerouslySetInnerHTML={{ __html: question }}></div>)}
                    </>
                  )}
                  {(chat.length > 0 && isCategorizedFollowUpQuestions(followUpQuestions) && followUpQuestions?.followUpQuestions?.length > 0) && <>
                    {followUpQuestions.followUpQuestions.map(({ category, questions }) => <div key={category} className="research__form__followup-category">
                      <div className="research__form__followup-category-title"><b>{category}</b></div>
                      {questions.map((question, idx) => <div key={idx} className="research__form__followup" onClick={this.handleClick} dangerouslySetInnerHTML={{ __html: question }}></div>)}
                    </div>)}
                  </>}
                </div>
              </div>
            </div>

            <div className="research__form__input-container">
              <div className="research__form__icon" onClick={this.handleClick} > <i className="material-icons">send</i></div>

              <TextareaAutosize
                rows="1"
                autoFocus
                className="research__form__input"
                onChange={this.handleClick}
                value={this.state.message || ""}
                onClick={this.handleClick}
              />
            </div>

          </div>
        </div>
        <ScrollToTop />
        {this.state.fullscreenImage && (
          <div className="image-fullscreen-modal" onClick={this.closeFullscreenImage}>
            <div className="image-fullscreen-modal__close">
              <i className="material-icons">close</i>
            </div>
            <img
              src={this.state.fullscreenImage}
              alt="Fullscreen"
              className="image-fullscreen-modal__image"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchCurrentUserData: () => dispatch(fetchCurrentUserData()),
    receiveCurrentUserData: (params) => dispatch(receiveCurrentUserData(params))
  }
};

const mapStateToProps = function (store) {
  const { rootReducers, userReducers } = store;
  const { userDataReducers } = rootReducers;
  const { mobileNavigationReducers } = userReducers;
  return {
    mobileNavigationStatus: mobileNavigationReducers.status,
    currentUserData: userDataReducers.currentUserData
  };
};

const delay = ms => new Promise(res => setTimeout(res, ms));

export default withResearchContext(connect(mapStateToProps, mapDispatchToProps)(Share));
